import "./SearchComp.css";
import { defineComponent as w, resolveComponent as d, openBlock as l, createElementBlock as u, normalizeStyle as _, createVNode as n, withCtx as s, withKeys as h, withDirectives as v, vShow as V, createElementVNode as i, toDisplayString as a, createCommentVNode as m, Fragment as S, renderList as g, createBlock as f } from "vue";
import { V as F } from "./WrapperComp.f674f2c9.js";
import { ButtonComp as $ } from "./ButtonComp.js";
import { OverflowComp as k } from "./OverflowComp.js";
import { InputComp as b } from "./InputComp.js";
import { IconComp as B } from "./IconComp.js";
import { u as T } from "./uniqueId.f48d78c2.js";
import { _ as I } from "./_plugin-vue_export-helper.dad06003.js";
const D = w({
  mixins: [F],
  components: {
    ButtonComp: $,
    OverflowComp: k,
    InputComp: b,
    IconComp: B
  },
  events: {
    "update:modelValue": {
      type: String
    },
    "update:optionSelected": {
      type: Object
    }
  },
  props: {
    id: {
      type: String,
      default: () => T("search"),
      required: !1
    },
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    placeholder: String,
    optionsText: String,
    emptyText: String,
    width: String,
    autocomplete: {
      type: String,
      default: "off"
    }
  },
  data() {
    return {
      show: !1,
      parentFocused: !1,
      childFocused: !1
    };
  },
  computed: {
    displayValue: {
      get() {
        return this.modelValue ?? "";
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    styleOverrides() {
      return {
        width: this.width
      };
    }
  },
  methods: {
    handleParentFocus() {
      this.open();
    },
    async handleParentBlur() {
      this.parentFocused = !1, await this.sleep(100), this.childFocused || this.close();
    },
    handleChildFocus() {
      this.childFocused = !0;
    },
    handleKeyEnter() {
      this.options.length === 1 && this.handleChildClick(this.options[0]), !this.options.length && this.displayValue !== "" && this.handleChildClick({ text: "none", value: "none" });
    },
    handleChildClick(e) {
      this.$emit("update:optionSelected", e), this.close();
    },
    async handleChildBlur() {
      this.childFocused = !1, await this.sleep(100), this.childFocused || this.close();
    },
    open() {
      !this.show && this.options.length > 0 && (this.parentFocused = !0, this.show = !0);
    },
    close() {
      this.show = !1;
    },
    async handleClear() {
      this.$emit("update:modelValue", "");
    },
    async sleep(e) {
      return new Promise((t) => setTimeout(t, e));
    }
  },
  watch: {
    displayValue(e, t) {
      e !== "" ? this.open() : (this.$emit("update:clearSearch"), this.close());
    }
  }
});
const K = {
  key: 0,
  class: "search__optionsText"
}, O = { class: "search__optionsTextItalic" }, P = { class: "search__optionsTextBold" }, q = { class: "search__optionResult" };
function E(e, t, A, N, M, R) {
  const c = d("icon-comp"), r = d("button-comp"), y = d("input-comp"), C = d("overflow-comp");
  return l(), u("div", {
    class: "search",
    style: _(e.styleOverrides)
  }, [
    n(C, {
      show: e.show,
      width: "100%",
      offsetDistance: "2px",
      disableIconRotation: ""
    }, {
      button: s(() => [
        n(y, {
          id: e.id,
          class: "search__input",
          type: "text",
          modelValue: e.displayValue,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.displayValue = o),
          onFocus: t[1] || (t[1] = (o) => e.handleParentFocus()),
          onBlur: t[2] || (t[2] = (o) => e.handleParentBlur()),
          onKeyup: [
            t[3] || (t[3] = h((o) => e.handleKeyEnter(), ["enter"])),
            t[4] || (t[4] = h((o) => e.close(), ["esc"]))
          ],
          placeholder: e.placeholder,
          autocomplete: e.autocomplete,
          disableMessages: "",
          selectAllOnFocus: "",
          medium: ""
        }, {
          prepend: s(() => [
            n(c, {
              class: "search__prependedIcon",
              icon: "search_small"
            })
          ]),
          append: s(() => [
            v(n(r, {
              onClick: e.handleClear,
              blank: "",
              "aria-label": "Clear Search"
            }, {
              default: s(() => [
                n(c, {
                  class: "search__appendedIcon",
                  icon: "close_small"
                })
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [V, e.displayValue !== ""]
            ])
          ]),
          _: 1
        }, 8, ["id", "modelValue", "placeholder", "autocomplete"])
      ]),
      content: s(() => [
        e.optionsText ? (l(), u("div", K, [
          i("span", O, a(e.optionsText) + " ", 1),
          i("span", P, a(e.displayValue), 1)
        ])) : m("", !0),
        (l(!0), u(S, null, g(e.options, (o) => (l(), f(r, {
          class: "search__option",
          key: o.text,
          onClick: (p) => e.handleChildClick(o),
          onFocus: t[5] || (t[5] = (p) => e.handleChildFocus()),
          onBlur: t[6] || (t[6] = (p) => e.handleChildBlur()),
          onKeyup: t[7] || (t[7] = h((p) => e.close(), ["esc"])),
          dropdown: "",
          dropdownDisabled: o.disabled,
          "t-sel": o.tSel
        }, {
          default: s(() => [
            i("p", null, a(o.text), 1),
            i("p", q, a(o.extra), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "dropdownDisabled", "t-sel"]))), 128)),
        e.options.length === 0 ? (l(), f(r, {
          key: 1,
          class: "textInputSelect__emptyText",
          dropdown: "",
          dropdownDisabled: ""
        }, {
          default: s(() => [
            i("p", null, a(e.emptyText), 1)
          ]),
          _: 1
        })) : m("", !0)
      ]),
      _: 1
    }, 8, ["show"])
  ], 4);
}
const W = /* @__PURE__ */ I(D, [["render", E], ["__scopeId", "data-v-8f86fca9"]]);
export {
  W as SearchComp
};
//# sourceMappingURL=SearchComp.js.map
